import { SHA512 } from "crypto-js";
import { api, loginapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const EmergencyAPIs = {

   
    GetEmergencyLinkVerified: async function (paymentCode, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/new/emergency/paymentcode/' + paymentCode,
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            signal: cancel ? cancelAPIObject[this.get.name].handleRequestCancellation().signal : undefined,
        })
        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostUseNewPortalEmergencyLink:  async function ( paymentCode, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/emergency/paymentcode/use/' + paymentCode,
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            signal: cancel ? cancelAPIObject[this.get.name].handleRequestCancellation().signal : undefined,
        })
        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    
}
const cancelAPIObject = defineCancelApiObject(EmergencyAPIs)